import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { withNamespaces } from "react-i18next";

import Select from "../form_components/Select/Select";
import WhiteButton from "../form_components/Buttons/WhiteButton/WhiteButton";

function SupplierEditBox({
  t,

  supplierStatus,
  searchText,
  setSearchText,

  tableFilter,
  setTableFilter,

  useFetchRender,
  setUseFetchRender,

  selectValueId,
  setSelectValueId,

  selectValue,
  setSelectValue,

  handleOpenDeleteModal,
  handleOpenAddSupplierModal,
  handleOpenApprovedSupplierModal,
  handleOpenRejectSupplierModal,
}) {
  const [isSearchOpen, setSearchOpen] = useState(false);
  const searchRef = useRef(null);

  /* SEARCH-START */
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setSearchOpen(false);
    }
  };
  /* DROPDOWN-END */

  /* process => Yapılacak işlem (düzenle,sil,..) */
  function handleClick(process) {
    switch (process) {
      case "render":
        console.log("Tablo yenilendi!");

        setUseFetchRender(!useFetchRender);

        setSearchOpen(false);

        setSelectValueId(null);
        setSelectValue(null);

        break;

      case "search":
        console.log("Bul a tıklandı!");
        // alert("Bul a tıklandı!");

        setSearchOpen(true);

        break;

      case "add-supplier":
        console.log("add-supplier a tıklandı!");

        setSearchOpen(false);

        break;

      case "delete":
        console.log("delete  tıklandı!");

        handleOpenDeleteModal();

        setSearchOpen(false);

        break;
      case "add-my-supplier":
        console.log("add-my-supplier  tıklandı!");

        handleOpenAddSupplierModal();

        setSearchOpen(false);

        break;

      case "approved-supplier":
        console.log("approved-supplier  tıklandı!");

        handleOpenApprovedSupplierModal();

        setSearchOpen(false);

        break;
      case "reject-supplier":
        console.log("reject-supplier  tıklandı!");

        handleOpenRejectSupplierModal();

        setSearchOpen(false);

        break;

      default:
        break;
    }
  }

  const selectOptions = [
    { key: 1, text: t("select_options_increased_price") },
    { key: 2, text: t("select_options_decreasing_price") },
    { key: 3, text: t("select_options_new_to_old") },
    { key: 4, text: t("select_options_old_to_new") },
  ];

  return (
    <div className="edit-container">
      <div className="edit-box">
        <div className="edit-container-title">
          <h4 className="title">
            {" "}
            <i className="fa-solid fa-star" /> {t("button_suppliers")}
          </h4>
        </div>

        <div className="edit-container-button-group">
          <WhiteButton
            icon={<i className="fa-solid fa-arrow-rotate-right" />}
            tooltip={t("button_edit_render")}
            onClick={() => handleClick("render")}
          />

          <WhiteButton
            icon={
              isSearchOpen ? (
                <div ref={searchRef} className="search-container">
                  <i className="fa-solid fa-magnifying-glass" />
                  <input
                    type="text"
                    placeholder={t("button_edit_search")}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              ) : (
                <i className="fa-solid fa-magnifying-glass" />
              )
            }
            tooltip={t("button_edit_search")}
            onClick={() => handleClick("search")}
          />

          {/* <Select
            name="filter"
            options={selectOptions}
            select={tableFilter}
            setSelect={setTableFilter}
            className="select-filter-sort"
          /> */}

          <Link
            to={
              selectValueId || selectValue
                ? `company-profile/${selectValueId}`
                : false
            }
          >
            <WhiteButton
              icon={<i className="fa-solid fa-info" />}
              tooltip={t("button_edit_detail")}
              disabled={selectValueId || selectValue ? false : true}
            />
          </Link>

          {supplierStatus === "Tavsiye Edilenler" ? (
            <WhiteButton
              icon={<i className="fa-solid fa-user-plus"></i>}
              tooltip={t("button_add_supplier")}
              onClick={() => handleClick("add-my-supplier")}
              disabled={selectValueId || selectValue ? false : true}
            />
          ) : supplierStatus === "Onay Bekleyenler" ? (
            <>
              <WhiteButton
                icon={<i className="fa-solid fa-check"></i>}
                tooltip={t("button_add_supplier")}
                onClick={() => handleClick("approved-supplier")}
                disabled={selectValueId || selectValue ? false : true}
              />
              <WhiteButton
                icon={<i className="fa-regular fa-circle-xmark"></i>}
                tooltip={t("reject_request_supplier_title")}
                onClick={() => handleClick("reject-supplier")}
                disabled={selectValueId || selectValue ? false : true}
              />
            </>
          ) : supplierStatus === "Reddedilen" ? null : (
            <>
              <WhiteButton
                icon={<i className="fa-solid fa-trash-can"></i>}
                tooltip={t("button_delete_supplier")}
                onClick={() => handleClick("delete")}
                disabled={selectValueId || selectValue ? false : true}
              />
              <Link to={`supplier-add`}>
                <WhiteButton
                  icon={<i className="fa-solid fa-plus"></i>}
                  tooltip={t("add_supplier_title")}
                  onClick={() => handleClick("add-supplier")}
                />
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default withNamespaces()(SupplierEditBox);
